// extracted by mini-css-extract-plugin
export var actions = "_8e-8";
export var arrow = "_8e-5";
export var card = "_8e-0";
export var cardWrapper = "_8e-9";
export var fieldName = "_8e-3";
export var newValue = "_8e-6";
export var oldValue = "_8e-4";
export var orangeGlowFade = "_8e-c";
export var productSection = "_8e-1";
export var scrollToBottom = "_8e-b";
export var scrollToBottomAnchor = "_8e-a";
export var scrollToBottomIcon = "_8e-d";
export var showAllButton = "_8e-7";
export var table = "_8e-2";